import React, { useCallback } from 'react';
import { HeaderProps } from './types';
import {
  StyledBreadcrumb,
  StyledCmdKHint,
  StyledHeader,
  StyledHeaderAction,
  StyledHeaderMobileToggle,
  StyledHeaderSpacer,
  StyledNotificationBell,
} from './styles';
import useHeaderTitleContext from '../../../hooks/useHeaderTitleContext';
import MenuDropdown from '../../molecules/MenuDropdown';
import Seo from '../../Seo';
import { IconChevronRight, IconClose, IconSearch } from '../../../assets/svg/icons';

const openPalette = () =>
  window.dispatchEvent(
    new KeyboardEvent('keydown', { metaKey: true, key: 'k', bubbles: true })
  );

const IconMenu = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
  >
    <line x1='3' y1='6' x2='21' y2='6' />
    <line x1='3' y1='12' x2='21' y2='12' />
    <line x1='3' y1='18' x2='21' y2='18' />
  </svg>
);

const BellIcon = () => (
  <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={1.75} strokeLinecap='round' strokeLinejoin='round'>
    <path d='M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9' />
    <path d='M13.73 21a2 2 0 0 1-3.46 0' />
  </svg>
);

const Header: React.FC<HeaderProps> = ({
  menu,
  centerComponent,
  onMenuToggle,
  mobileMenuOpen,
  workspaceName,
  userInitials,
}) => {
  const { title } = useHeaderTitleContext();
  const handleCmdK = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    openPalette();
  }, []);

  return (
    <>
      <Seo {...{ title }} />
      <StyledHeader>
        {onMenuToggle && (
          <StyledHeaderMobileToggle
            type='button'
            onClick={onMenuToggle}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {mobileMenuOpen ? <IconClose /> : <IconMenu />}
          </StyledHeaderMobileToggle>
        )}

        {/* Breadcrumb */}
        <StyledBreadcrumb>
          {workspaceName && (
            <>
              <span className='ws-name'>{workspaceName}</span>
              <span className='chev'><IconChevronRight /></span>
            </>
          )}
          {title && <span className='page-title'>{title}</span>}
        </StyledBreadcrumb>

        <StyledHeaderSpacer />
        {centerComponent}

        <StyledHeaderAction>
          {/* Full search bar / ⌘K trigger */}
          <StyledCmdKHint
            type='button'
            onClick={handleCmdK}
            title='Search & navigate (⌘K)'
          >
            <span className='search-icon'><IconSearch /></span>
            <span className='placeholder'>Search orders, customers, SKUs…</span>
            <kbd>⌘K</kbd>
          </StyledCmdKHint>

          {/* User avatar / account dropdown */}
          {menu && (
            <MenuDropdown {...menu} userInitials={userInitials} />
          )}
        </StyledHeaderAction>
      </StyledHeader>
    </>
  );
};

export default Header;
